import React from 'react';

import FancyHeadings from '~/components/seed/fancy-headings';
import SeedProductForm from '~/components/seed/seed-product-form';
import ShippingBadge from '~/components/sunday-store/components/product-details/shipping-badge';
import { urlFor } from '~/sanity/images';
import FeatureBadge from '~/components/seed/feature-badge';

import styles from '~/components/seed/seed-finder.module.scss';

const MainRecommendation = ({
  product,
  seedingPurposeContent,
  seedingSquareFootage,
  showAddedToCartModal,
  showProductDetailsModal,
}) => {
  const {
    displayName,
    lawnFeature,
    productDetails,
    purchaseSku,
    quantity,
    seedDescription,
  } = product || {};

  return (
    <div className={styles.mainRecommendation}>
      <div className={styles.leftColumn}>
        <button
          className={styles.learnMoreButton}
          onClick={() => showProductDetailsModal(product)}
        >
          <img
            className={styles.desktopImage}
            src={urlFor(productDetails?.primaryImage?.asset)
              .width(1000)
              .height(1000)
              .fit('crop')
              .crop('focalpoint')}
            alt={productDetails?.primaryImage?.alt}
          />
        </button>
      </div>
      <div className={styles.rightColumn}>
        <FancyHeadings h1Copy="Your best bet" h2Copy={displayName} />
        <div className={styles.yourLawn}>
          <p className={styles.heading}>Your lawn at a glance</p>
          <div className={styles.badgeContainer}>
            <FeatureBadge
              text={seedingPurposeContent?.text}
              icon={{
                src: seedingPurposeContent?.icon,
                alt: seedingPurposeContent?.alt,
              }}
            />
            {lawnFeature && (
              <FeatureBadge
                text={lawnFeature?.text}
                icon={{ src: lawnFeature?.icon, alt: lawnFeature?.alt }}
              />
            )}
          </div>
        </div>
        <div className={styles.imageAndDescription}>
          <button
            className={styles.learnMoreButton}
            onClick={() => showProductDetailsModal(product)}
          >
            <img
              src={urlFor(productDetails?.primaryImage?.asset)}
              alt={productDetails?.primaryImage?.alt}
            />
          </button>
          <div>
            <p>{seedDescription}</p>
            <button
              className={styles.learnMoreButton}
              onClick={() => showProductDetailsModal(product)}
            >
              Learn more
            </button>
          </div>
        </div>

        <p className={styles.bagQuantityRecommendation}>
          For {seedingPurposeContent?.displayText} at{' '}
          <strong>{seedingSquareFootage?.toLocaleString()} sq ft</strong>,
          you'll need <strong>{quantity}</strong>.
        </p>
        <SeedProductForm
          productDetails={productDetails}
          purchaseSku={purchaseSku}
          quantity={quantity}
          afterSubmit={() => showAddedToCartModal(product)}
        />
        <div className={styles.shippingBadgeContainer}>
          <ShippingBadge
            productDetails={productDetails}
            purchaseSku={purchaseSku}
          />
        </div>
      </div>
    </div>
  );
};

export default MainRecommendation;
